"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const reviewer_1 = __importDefault(require("./reviewer"));
const USER_TYPE = 'users';
const CurrentAssignedReviewer = (props) => {
    const { assignedReviewers } = props;
    const isMulti = Array.isArray(assignedReviewers) && assignedReviewers.length > 1;
    let reviewer;
    if (!isMulti) {
        reviewer = !Array.isArray(assignedReviewers)
            ? assignedReviewers
            : assignedReviewers[0];
    }
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('current-reviewer uk-flex', {
            'current-reviewer--multi': isMulti,
        }) },
        isMulti && (react_1.default.createElement(pulse_components_1.PulseWithMore, { childrenKey: "data-reviewer-id", classes: {
                root: 'uk-margin-small-left',
                more: {
                    label: {
                        root: 'current-reviewer__with-more-label',
                        active: 'current-reviewer__with-more-label--active',
                    },
                },
                hidden: {
                    root: 'current-reviewer__hidden-root',
                    content: 'current-reviewer__hidden-content',
                },
            }, MoreLabelProps: {
                size: pulse_components_1.LabelSizes.sm,
            }, TippyPropsHidden: {
                appendTo: 'parent',
                popperOptions: {
                    strategy: 'fixed',
                },
            }, HiddenChildProps: {
                displayIcon: true,
            } }, assignedReviewers.map((user) => (react_1.default.createElement(reviewer_1.default, { key: user.id, reviewer: user }))))),
        !isMulti && reviewer && (react_1.default.createElement(reviewer_1.default, { reviewer: reviewer, TippyProps: {
                disabled: reviewer.type === USER_TYPE,
            }, classes: {
                root: 'uk-margin-small-left',
            } }))));
};
exports.default = CurrentAssignedReviewer;
